import React, { useMemo } from 'react';
import { transChannel } from '@/pages/opinion/utils';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { getChartBufferWidth } from '@op/utils/systemUtil';

export default function ({
  statistics = { x: [], y: [] },
  text,
  formatValueFunc,
  dateType,
  topicName,
  height = 40,
  seriesProps = {},
}: {
  statistics?: { x: never[]; y: never[] } | undefined;
  text: any;
  formatValueFunc: any;
  dateType: any;
  topicName: string;
  height?: number;
  seriesProps?: any;
}) {
  const options = useMemo(() => {
    const legendData: {
      name: string;
      itemStyle: {
        color: string;
      };
    }[] = [];
    const xAxisData: string[] = statistics?.x || [];
    const seriesData: any[] = [
      {
        symbol: 'circle',
        symbolSize: 0,
        data: statistics?.y || [],
        type: 'line',
        lineStyle: {
          width: 2,
          color: '#326FF0',
        },
        ...seriesProps
      },
    ];

    const option = {
      tooltip: {
        appendToBody: true,
        position() {
          return { top: -80, right: -10 };
        },
        confine: false,
        formatter: (param: any) => {
          const { axisValue } = param?.[0] || {};
          return formatChartParamsDate({
            params: param,
            listTitleFunc: () => topicName,
            valueFormat: formatValueFunc,
            tablesConfigFunc: (records: Array<any>) => [
              {
                showHeader: true,
                records,
                columns: [
                  {
                    key: 'text',
                    header: listTimeTitleFunc(axisValue, dateType),
                  },
                  {
                    key: 'value',
                    align: 'right',
                    weight: 'bold',
                    header: text,
                  },
                ],
              },
            ],
          });
        },
      },
      legend: {
        data: legendData,
        formatter: (params: any) => transChannel(params),
      },
      grid: {
        top: '5px',
        left: getChartBufferWidth(5),
        right: '5px',
        bottom: '5px',
        containLabel: false,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: 0,
          data: xAxisData,
          axisLabel: false,
          axisLine: false,
          axisTick: false,
          splitLine: false,
        },
      ],
      yAxis: {
        type: 'value',
        splitLine: false,
        axisLabel: false,
        boundaryGap: 0,
      },
      series: seriesData,
    };

    return option;
  }, [statistics, topicName]);

  return (
    <EChartCommon
      options={options}
      height={height}
      optionsProps={{ excludeOptions: ['axisPointer'] }}
    ></EChartCommon>
  );
}
